module.exports = __webpack_public_path__ + "static/image/logo-family/new_logo_takeout.ver2_0_2.png?a919e107";